import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import LabelInput from '@components/LabelInput/LabelInput';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import Css from './ReadyToJoin.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalBody, Modal } from 'reactstrap';
import ImportImages from '@src/importImages';
import axiosInstance from '@src/axios-instance';

const Clouds = ImportImages('/home/clouds.jpg');

class ReadyToJoin extends Component {
  state = {
    showMoreInfo: true,
    status: 0,
    modalActive: false,
    wholeAircraft: true,
    formData: {
      FirstName: '',
      LastName: '',
      Email: '',
      Phone: '',
      //howdidyouhearaboutJetSuite: '',
      Home_Airport__c: '',
      estimatedFlightHoursorofprivateflightsperyear: '',
      currentSolution: '',
      //primaryTravelType: '',
      primaryDestinations: '',
      //bestTimeforaRepresentativetoFollowUp: '',
      leadPartitionIDCustom: 'JS',
      travelType: 'Aircraft Charter'
    }
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current
    });
  };

  componentDidMount = () => {
    window.addEventListener('marketo-submitted-1043', this.formSubmitted, true);
    window.addEventListener(
      'marketo-submitting-1043',
      this.formSubmitting,
      true
    );
  };

  componentWillUnmount = () => {
    window.removeEventListener(
      'marketo-submitted-1043',
      this.formSubmitted,
      true
    );
    window.removeEventListener(
      'marketo-submitting-1043',
      this.formSubmitting,
      true
    );
  };

  formSubmitted = () => {
    this.submitingHandler(2);
  };

  formSubmitting = () => {
    this.submitingHandler(1);
  };

  submitFormLog = () => {
    const postData = {
      event: 'suitekey_membership_form_submission',
      event_category: 'Form Submission',
      form_data: JSON.stringify(this.state.formData)
    };
    axiosInstance()
      .post('/forms/saveForm.json', postData)
      .then(response => {
        if (response.result && this.state.formData.FirstName.length > 0) {
          window.gtag('event', 'suitekey_membership_form_submission', {
            event_category: 'Form Submission'
          });
        }
      });
  };

  submitingHandler = status => {
    this.setState({
      status: status
    });

    if (status === 2) {
      this.submitFormLog();

      setTimeout(() => {
        this.setState({
          showMoreInfo: true,
          status: 0,
          formData: {
            FirstName: '',
            LastName: '',
            Email: '',
            Phone: '',
            howdidyouhearaboutJetSuite: '',
            Home_Airport__c: '',
            estimatedFlightHoursorofprivateflightsperyear: '',
            currentSolution: '',
            //primaryTravelType: '',
            primaryDestinations: '',
            //bestTimeforaRepresentativetoFollowUp: '',
            leadPartitionIDCustom: 'JS',
            travelType: 'Aircraft Charter'
          }
        });
      }, 2000);
    }
  };

  updateForm = (event, name) => {
    const currentData = { ...this.state.formData };
    currentData[name] = event.target.value;

    this.setState({
      formData: { ...currentData }
    });
  };

  submitHandler = () => {
    let formValid = true;
    for (let index in this.state.formData) {
      if (
        document.querySelectorAll('input[name=' + index + 'Join]').length > 0
      ) {
        if (this.state.formData[index].length === 0) {
          document.querySelector('input[name=' + index + 'Join]').className +=
            ' error';
          formValid = false;
        } else {
          document
            .querySelector('input[name=' + index + 'Join]')
            .classList.remove('error');
        }
      }
    }
    if (formValid) {
      window.gtag_report_conversion_form();
      let myForm = window.marketo.getForm(1043);
      myForm.addHiddenFields({ ...this.state.formData });
      myForm.submitEvent = 1043;
      myForm.submit();
    }
  };

  moreInfoClickHandler = event => {
    const showInfo = this.state.showMoreInfo;
    this.setState({
      showMoreInfo: !showInfo
    });
  };

  render() {
    let heightStyle = {
      height: this.props.screenHeight + 'px'
    };

    return (
      <React.Fragment>
        <div className={this.props.className} style={heightStyle}>
          <img src={Clouds} alt={'Slider1'} className={'img-fluid'} />
          <Container fluid={true} className={'abs-container'}>
            <Row className={'justify-content-center h-100'}>
              <Col
                md={9}
                className={
                  Css['form-container'] +
                  ' align-self-center h-60 background-white'
                }
              >
                {this.state.status === 1 && (
                  <ProgressBox
                    text={'Submitting ...'}
                    icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
                  />
                )}
                {this.state.status === 2 && (
                  <ProgressBox
                    text={'Submitted!'}
                    icon={<FontAwesomeIcon icon={['far', 'check-circle']} />}
                  />
                )}

                <Container
                  fluid={true}
                  className={Css.scrollable + ' scrollable'}
                >
                  <div className={Css.header}>Join Our Community</div>

                  <Row className={'asap-regular mb-2'}>
                    <Col>
                      <div>
                        <label className={'font-md mb-1'}>
                          Are you interested in whole aircraft charter or per
                          seat fare?
                        </label>
                        <label
                          htmlFor="charter-option-join-1"
                          className={'font-md d-block mb-1'}
                        >
                          <input
                            type={'radio'}
                            name={'charterOptionJoin'}
                            id={'charter-option-join-1'}
                            className={'mr-2'}
                            value={'Aircraft Charter'}
                            checked={
                              this.state.formData['travelType'] ===
                              'Aircraft Charter'
                            }
                            onChange={event =>
                              this.updateForm(event, 'travelType')
                            }
                          />
                          &nbsp;whole aircraft charter
                        </label>
                        <label
                          htmlFor="charter-option-join-2"
                          className={'font-md d-block'}
                        >
                          <input
                            type={'radio'}
                            name={'charterOptionJoin'}
                            id={'charter-option-join-2'}
                            className={'mr-2'}
                            checked={
                              this.state.formData['travelType'] ===
                              'Per Seat Fare'
                            }
                            onChange={event =>
                              this.updateForm(event, 'travelType')
                            }
                            value={'Per Seat Fare'}
                          />
                          &nbsp;per seat fare
                        </label>
                      </div>
                    </Col>
                  </Row>

                  <Row className={'pb-4'}>
                    <Col md={5}>
                      <LabelInput
                        label={'First Name'}
                        type={'text'}
                        name={'FirstNameJoin'}
                        value={this.state.formData['FirstName']}
                        onChange={event => this.updateForm(event, 'FirstName')}
                      />
                    </Col>
                    <Col md={7}>
                      <LabelInput
                        label={'Last Name'}
                        type={'text'}
                        name={'LastNameJoin'}
                        value={this.state.formData['LastName']}
                        onChange={event => this.updateForm(event, 'LastName')}
                      />
                    </Col>
                  </Row>
                  <Row className={'pb-4'}>
                    <Col md={5}>
                      <LabelInput
                        label={'Phone'}
                        type={'text'}
                        name={'PhoneJoin'}
                        value={this.state.formData['Phone']}
                        onChange={event => this.updateForm(event, 'Phone')}
                      />
                    </Col>
                    <Col md={7}>
                      <LabelInput
                        label={'Email'}
                        type={'email'}
                        name={'EmailJoin'}
                        value={this.state.formData['Email']}
                        onChange={event => this.updateForm(event, 'Email')}
                      />
                    </Col>
                  </Row>

                  {/* <Row className={'pb-4 pt-3 d-none'}>
                  <Col md={5}>
                    <div
                      className={'asap-regular pointer'}
                      onClick={this.moreInfoClickHandler}
                    >
                      {this.state.showMoreInfo ? (
                        <FontAwesomeIcon
                          icon={['far', 'chevron-circle-up']}
                          className={'font-xl float-left mr-2'}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={['far', 'chevron-circle-down']}
                          className={'font-xl float-left mr-2'}
                        />
                      )}
                      <span className={'font-md'}>
                        Provide more info (optional)
                      </span>
                    </div>
                  </Col>
                  {!this.state.showMoreInfo && (
                    <Col md={7}>
                      <button
                        type={'button'}
                        className={'btn btn-primary'}
                        onClick={this.submitHandler}
                      >
                        Submit
                      </button>
                    </Col>
                  )}
                </Row> */}

                  {this.state.showMoreInfo && (
                    <React.Fragment>
                      <Row className={'pb-4'}>
                        <Col md={5}>
                          <LabelInput
                            label={'Home Airport'}
                            type={'text'}
                            name={'Home_Airport__cJoin'}
                            value={this.state.formData['Home_Airport__c']}
                            onChange={event =>
                              this.updateForm(event, 'Home_Airport__c')
                            }
                          />
                        </Col>
                        <Col md={7}>
                          <LabelInput
                            label={'Estimated Flight Hours Per Year'}
                            type={'number'}
                            name={
                              'estimatedFlightHoursorofprivateflightsperyearJoin'
                            }
                            value={
                              this.state.formData[
                                'estimatedFlightHoursorofprivateflightsperyear'
                              ]
                            }
                            onChange={event =>
                              this.updateForm(
                                event,
                                'estimatedFlightHoursorofprivateflightsperyear'
                              )
                            }
                          />
                        </Col>
                      </Row>

                      <Row className={'pb-4'}>
                        <Col md={5}>
                          <LabelInput
                            label={'Primary Destinations'}
                            name={'primaryDestinationsJoin'}
                            type={'text'}
                            value={this.state.formData['primaryDestinations']}
                            onChange={event =>
                              this.updateForm(event, 'primaryDestinations')
                            }
                          />
                        </Col>
                        <Col md={7}>
                          <LabelInput
                            label={'Current Solution'}
                            type={'text'}
                            name={'currentSolutionJoin'}
                            placeholder={
                              'Fractional, Jet Card, Charter, Commercial, etc.'
                            }
                            value={this.state.formData['currentSolution']}
                            onChange={event =>
                              this.updateForm(event, 'currentSolution')
                            }
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col className={'col-auto'}>
                          <div className={'mb-1'}>
                            <label
                              htmlFor="ready-newsletter-check"
                              className={'js-checkbox mt-2'}
                            >
                              <input
                                type={'checkbox'}
                                id={'ready-newsletter-check'}
                                defaultChecked={true}
                              />
                              <FontAwesomeIcon
                                icon={['far', 'square']}
                                className={'fa-2x'}
                              />
                              <FontAwesomeIcon
                                icon={['far', 'check-square']}
                                className={'fa-2x color-red'}
                              />
                              <span className={'font-md mt-2'}>
                                I would like to receive emails from JetSuite
                                about promotions, news and updates.
                              </span>
                            </label>
                          </div>
                        </Col>
                        <Col className={'text-right'}>
                          <button
                            type={'button'}
                            className={'btn btn-primary'}
                            onClick={this.submitHandler}
                          >
                            Submit
                          </button>
                        </Col>
                      </Row>
                    </React.Fragment>
                  )}
                </Container>
              </Col>
            </Row>
          </Container>
        </div>
        <Modal
          isOpen={this.state.modalActive}
          toggle={this.toggleModal}
          className={
            'modal-lg h-100 d-flex flex-column justify-content-center my-0'
          }
        >
          <ModalBody style={{ backgroundColor: '#eeeeee' }} className={'p-0'}>
            <div className="p-3 text-center">
              JetSuite Inc. is an on-demand, whole aircraft charter service.
              <br />
              For per seat, daily service, please see{' '}
              <a href="https://www.jetsuitex.com" className={'red-link'}>
                www.jetsuitex.com
              </a>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ReadyToJoin;



// WEBPACK FOOTER //
// ./src/components/SuiteKey/ReadyToJoin/ReadyToJoin.js